import { render, staticRenderFns } from "./SelectStrategyImportFromIDML.vue?vue&type=template&id=da63d472"
import script from "./SelectStrategyImportFromIDML.vue?vue&type=script&lang=js"
export * from "./SelectStrategyImportFromIDML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports